import React from "react";
import { ErrorMessage } from "formik";

export const FieldErrorMessage = ({name}) => (<ErrorMessage name={name} className="error">{msg => <div className="error">{msg}</div>}</ErrorMessage>)